<template>
  <div
    v-show="count > 0"
    class="sm-tab"
  >
    <template v-for="(value, key, index) in showNavList">
      <a
        v-if="value.show"
        :id="key"
        :key="index"
        :class="[type === key && count > 1 ? 'cur' : '', 'tab']"
        @click="navClick"
      >
        {{ value.content }}
      </a>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { singlePageClParams } from '../../common/js/util';

export default {
  data() {
    return {
      count: 0,
    };
  },
  computed: {
    ...mapState('summary', ['itemData']),
    type() {
      return this.$route.params.type;
    },
    showNavList() {
      const ret = {
        plot: {
          show: false,
          content: '分集剧情',
        },
        still: {
          show: false,
          content: '剧照',
        },
        cast: {
          show: false,
          content: '角色介绍',
        },
      };
      const item = this.itemData;
      if (item) {
        const { plot_info: plotInfo, role_info: roleInfo, photo } = item;
        if (plotInfo && plotInfo.content) {
          ret.plot.show = true;
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.count += 1;
        }
        if (roleInfo && roleInfo.item_list && roleInfo.item_list.length > 0) {
          ret.cast.show = true;
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.count += 1;
        }
        if (photo && photo.item_list && photo.item_list.length > 0) {
          ret.still.show = true;
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.count += 1;
        }
      }
      return ret;
    },
  },
  methods: {
    navClick(e) {
      const { id } = e.target;
      if (id) {
        const { type } = this.$route.params;
        if (id === type) return;
        const { query } = this.$route;
        const url = `/summary/${id}?${this.myStringify(query)}`;
        const clParams = singlePageClParams(`nav_${id}&href=${url}`);
        this.$uigs.send(clParams);
        location.href = url;
      }
    },
    myStringify(obj) {
      let queryStr = '';
      const queryArr = [];
      Object.keys(obj).forEach((key) => {
        queryArr.push(`${key}=${encodeURIComponent(obj[key])}`);
      });
      queryStr = queryArr.join('&');
      return queryStr;
    },
  },
};
</script>

<style lang="scss">
.sm-tab {
  border-bottom: 1px solid #f5f5f5;
  height: 48px;
  line-height: 48px;
  margin: 0 15px;
  display: flex;
  justify-content: space-around;

  a:nth-last-child(1):first-child {
    width: 100%;
    font-weight: 700;
    color: rgba(34, 34, 34, 1);
    text-align: left;
  }
}

.sm-tab a {
  width: 68px;
  font-size: 17px;
  color: rgba(85, 85, 85, 1);
  position: relative;
  text-align: center;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.sm-tab a.cur {
  font-weight: 700;
  color: rgba(34, 34, 34, 1);
}

.sm-tab a.cur:after {
  content: '';
  position: absolute;
  left: 25%;
  top: 46px;
  width: 34px;
  height: 2px;
  background: rgba(0, 0, 0, 1);
  border-radius: 1px;
}
</style>
